
import greenLogo from '../assets/images/logos/green-logo.svg'

import investorConnectLogo from '../assets/images/logos/investor-connect-transparent-logo.png'

import { useNavigate } from "react-router-dom";

import lightGreenArrowOutline from '../assets/images/light-outline-arrow.svg'

import growthConnectLogoGreen from '../assets/images/logos/4.png'

import { useStore } from "../App";

import { formatTime } from "../utils/formatTime";

import mapIcon from '../assets/images/map-icon.png'
import venueImg from '../assets/images/venue.png'


const PrivateHeader = ({ slotInformation, activeTab, setActiveTab, isDetailPage, isSlotPage = false, isDashboardPage, companyName }) => {
    const user = useStore.getState()


    const navigate = useNavigate()

    const tabs = user?.userType == "investor" ? ['Agenda', 'All Meetings', 'My Meetings', 'Feedback', 'Quick Assist'] : ['Agenda', 'Meeting Slots', 'All Investors', 'Feedback', 'Quick Assist'];
    // const tabs = user?.userType == "investor" ? ['All Meetings', 'My Meetings'] : ['Meeting Slots', 'All Investors'];



    const logOut = () => {
        useStore.setState({ userStatus: false });
        useStore.setState({ userType: null });
        useStore.setState({ accessToken: null });
        useStore.setState({ refreshToken: null });
        useStore.setState({ name: null });
        useStore.setState({ email: null });

        navigate('/');
    }

    return (
        <>

            <div className="private-header">

                <div className="top-row">
                    <img className="logo" src={greenLogo} alt="" />
                    <p className="cursor-pointer log-out mb-0" onClick={logOut}> Log Out <img src={lightGreenArrowOutline} alt="" /> </p>
                </div>

                <img className="main-logo" src={growthConnectLogoGreen} alt="" />




                {(isDetailPage || isSlotPage) &&

                    <div className="text-left">
                        <p className="log-out d-flex align-items-center cursor-pointer" onClick={() => navigate(user?.userType == "investor" ? '/dashboard?tab=All+Meetings' : '/dashboard?tab=Meeting+Slots')}><img className="back-icon" src={lightGreenArrowOutline} alt="" /><span className="cursor-pointer">Back</span></p>
                    </div>

                }

                {
                    !isSlotPage &&
                    <>
                    <h1>
                        Welcome {user.name}
                    </h1>
                            
                    <button className='venue-button'
                    onClick={() => window.open('/company/venue', "_blank")}
                    > 

                            <img src={mapIcon} alt="" />
                        View Venue</button>
                    </>
                }

                {
                    user?.userType == "company" && !isSlotPage
                    &&
                    <p style={{ fontWeight: 'bold' }}>{user?.location}</p>
                }


                {
                    isDetailPage && <h3 style={{ fontWeight: 'bold', marginTop: '5px' }}>{companyName}</h3>
                }

                {
                    isDashboardPage &&
                    <div className="tabs mt-4">
                        {tabs.map((tab) => (
                            <div
                                key={tab}
                                className={`tab ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </div>
                        ))}

                    </div>
                }

                {
                    isSlotPage &&
                    <>
                        <h3 style={{ fontWeight: 'bold', marginTop: '5px' }}>Day {slotInformation?.day}</h3>
                        <h3 style={{ fontWeight: 'bold', marginTop: '5px' }}>{slotInformation?.meeting}</h3>
                        <p style={{ fontSize: '0.75rem', fontWeight: 'bold' }}>{formatTime(slotInformation?.start_time)} - {formatTime(slotInformation?.end_time)}</p>
                    </>
                }
            </div>

        </>
    )
}


export default PrivateHeader;